<template>
    <div>
    <!-- 移动端卡片模式 -->
    <div v-if="cardMode" class="space-y-3">
        <!-- 手动刮削按钮卡片 -->
        <div class="card bg-base-100 border border-base-200 hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
            <div class="card-body p-4">
                <div @click="handModifyCheckBox = true" class="flex items-center justify-between cursor-pointer">
                    <div class="flex items-center space-x-3">
                        <div class="p-2 bg-primary/10 rounded-lg">
                            <svg viewBox="0 0 15 15" class="w-6 h-6 fill-primary" xmlns="http://www.w3.org/2000/svg">
                                <path d="M12.9697 0.969727L4.96973 8.96973L6.03039 10.0304L14.0304 2.03039L12.9697 0.969727Z" />
                                <path d="M2.5 1.25006C1.25736 1.25006 0.25 2.25742 0.25 3.50006V12.5001C0.25 13.7427 1.25736 14.7501 2.5 14.7501H11.5C12.7426 14.7501 13.75 13.7427 13.75 12.5001V7.00006H12.25V12.5001C12.25 12.9143 11.9142 13.2501 11.5 13.2501H2.5C2.08579 13.2501 1.75 12.9143 1.75 12.5001V3.50006C1.75 3.08585 2.08579 2.75006 2.5 2.75006H8V1.25006H2.5Z" />
                            </svg>
                        </div>
                        <div>
                            <div class="font-medium text-base-content">{{ $tt('手动刮削') }}</div>
                            <div class="text-sm text-base-content/70">{{ $tt('手动编辑音乐标签信息') }}</div>
                        </div>
                    </div>
                    <div class="flex-shrink-0">
                        <span class="loading loading-infinity loading-md text-primary" v-if="isLoading"></span>
                        <svg v-else class="w-5 h-5 fill-current text-base-content/50" viewBox="0 0 20 20">
                            <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
        
        <!-- 自动刮削按钮卡片 -->
        <div class="card bg-base-100 border border-base-200 hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
            <div class="card-body p-4">
                <div @click="autoModifyCheckBox = true" class="flex items-center justify-between cursor-pointer">
                    <div class="flex items-center space-x-3">
                        <div class="p-2 bg-primary/10 rounded-lg">
                            <svg t="1733029861980" class="w-6 h-6 fill-primary" viewBox="0 0 1036 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="9646">
                                <path d="M938.74776 69.162438L893.455144 52.837457a67.26383 67.26383 0 1 0-20.007307 64.317969l42.469499 15.465771c28.722146 10.433258 53.516478 49.097686 53.516478 83.466066v598.869028c0 34.000148-24.548843 72.664576-53.639223 82.729601l-38.296195 13.501863a67.26383 67.26383 0 1 0 14.115585 66.650109l46.397313-16.447724c55.60313-19.51633 98.195372-83.711555 98.195373-146.311105V216.210008c0-62.354061-42.960475-126.917519-98.195373-147.293059zM222.16703 888.971053a66.895597 66.895597 0 0 0-52.166292 24.548843L121.516773 897.440403A89.1123 89.1123 0 0 1 67.26383 822.443688V208.722611a89.97151 89.97151 0 0 1 54.252943-76.101414l51.920803-18.657121a67.632063 67.632063 0 1 0-15.465771-65.913643L98.195372 69.285182A157.358084 157.358084 0 0 0 0 208.722611v613.721077a156.253386 156.253386 0 0 0 99.30007 138.332731L159.56748 982.011168a67.509318 67.509318 0 1 0 62.59955-93.040115z" />
                                <path d="M426.29066 572.413721l86.780161-205.105584 91.935417 205.105584z m282.311696 230.759125h119.798354l-267.58239-592.854561-98.195372 1.104698-251.625642 592.118096 118.079936-1.350187L380.507068 680.183142h272.492158l55.112153 122.744215z" />
                            </svg>
                        </div>
                        <div>
                            <div class="font-medium text-base-content">{{ $tt('自动刮削') }}</div>
                            <div class="text-sm text-base-content/70">{{ $tt('自动匹配音乐标签信息') }}</div>
                        </div>
                    </div>
                    <div class="flex-shrink-0">
                        <span class="loading loading-infinity loading-md text-primary" v-if="isLoading"></span>
                        <svg v-else class="w-5 h-5 fill-current text-base-content/50" viewBox="0 0 20 20">
                            <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>

        <!-- 后台刮削按钮卡片 -->
        <div class="card bg-base-100 border border-base-200 hover:shadow-lg transition-all duration-200 hover:scale-[1.02]">
            <div class="card-body p-4">
                <div @click="backgroundScrapeCheckBox = true" class="flex items-center justify-between cursor-pointer">
                    <div class="flex items-center space-x-3">
                        <div class="p-2 bg-secondary/10 rounded-lg">
                            <svg-icon name="sys-backend" class="w-5 h-5 fill-current" />
                        </div>
                        <div>
                            <div class="font-medium text-base-content">{{ $tt('后台刮削') }}</div>
                            <div class="text-sm text-base-content/70">{{ $tt('查看后台刮削配置信息') }}</div>
                        </div>
                    </div>
                    <div class="flex-shrink-0">
                        <span class="loading loading-infinity loading-md text-primary" v-if="isLoading"></span>
                        <svg v-else class="w-5 h-5 fill-current text-base-content/50" viewBox="0 0 20 20">
                            <path fill-rule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z" clip-rule="evenodd"/>
                        </svg>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 桌面端原有模式 -->
    <div v-else>
        <!-- 手动刮削按钮 -->
        <div class="mt-2">
            <div for="hand-edit"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                :data-tip="$tt('手动刮削')" @click="handModifyCheckBox = true">
                <span class="loading loading-infinity loading-md text-primary" v-if="isLoading"></span>
                <span v-else :class="['flex mt-1', 'items-center', detail ? 'w-40' : '']">
                    <svg viewBox="0 0 15 15" class="icon fill-current w-16 h-5" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12.9697 0.969727L4.96973 8.96973L6.03039 10.0304L14.0304 2.03039L12.9697 0.969727Z" />
                        <path
                            d="M2.5 1.25006C1.25736 1.25006 0.25 2.25742 0.25 3.50006V12.5001C0.25 13.7427 1.25736 14.7501 2.5 14.7501H11.5C12.7426 14.7501 13.75 13.7427 13.75 12.5001V7.00006H12.25V12.5001C12.25 12.9143 11.9142 13.2501 11.5 13.2501H2.5C2.08579 13.2501 1.75 12.9143 1.75 12.5001V3.50006C1.75 3.08585 2.08579 2.75006 2.5 2.75006H8V1.25006H2.5Z" />
                    </svg>
                    <div v-if="detail" class="mr-auto">{{ $tt('手动刮削') }}</div>
                </span>
            </div>
        </div>

        <!-- 自动刮削按钮 -->
        <div class="mt-2">
            <div @click="autoModifyCheckBox = true"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                :data-tip="$tt('自动刮削')">
                <span class="loading loading-infinity loading-md text-primary" v-if="isLoading"></span>
                <span v-else :class="['flex mt-1', 'items-center', detail ? 'w-40' : '']">
                    <svg t="1733029861980" class="icon fill-current w-16 h-5" viewBox="0 0 1036 1024" version="1.1"
                        xmlns="http://www.w3.org/2000/svg" p-id="9646" width="200" height="200">
                        <path
                            d="M938.74776 69.162438L893.455144 52.837457a67.26383 67.26383 0 1 0-20.007307 64.317969l42.469499 15.465771c28.722146 10.433258 53.516478 49.097686 53.516478 83.466066v598.869028c0 34.000148-24.548843 72.664576-53.639223 82.729601l-38.296195 13.501863a67.26383 67.26383 0 1 0 14.115585 66.650109l46.397313-16.447724c55.60313-19.51633 98.195372-83.711555 98.195373-146.311105V216.210008c0-62.354061-42.960475-126.917519-98.195373-147.293059zM222.16703 888.971053a66.895597 66.895597 0 0 0-52.166292 24.548843L121.516773 897.440403A89.1123 89.1123 0 0 1 67.26383 822.443688V208.722611a89.97151 89.97151 0 0 1 54.252943-76.101414l51.920803-18.657121a67.632063 67.632063 0 1 0-15.465771-65.913643L98.195372 69.285182A157.358084 157.358084 0 0 0 0 208.722611v613.721077a156.253386 156.253386 0 0 0 99.30007 138.332731L159.56748 982.011168a67.509318 67.509318 0 1 0 62.59955-93.040115z">
                        </path>
                        <path
                            d="M426.29066 572.413721l86.780161-205.105584 91.935417 205.105584z m282.311696 230.759125h119.798354l-267.58239-592.854561-98.195372 1.104698-251.625642 592.118096 118.079936-1.350187L380.507068 680.183142h272.492158l55.112153 122.744215z">
                        </path>
                    </svg>
                    <div v-if="detail" class="mr-auto">{{ $tt('自动刮削') }}</div>
                </span>
            </div>
        </div>

        <!-- 后台刮削按钮 -->
        <div class="mt-2">
            <div @click="backgroundScrapeCheckBox = true"
                :class="['btn-ghost btn btn-sm hover:bg-neutral hover:text-neutral-content drawer-button', !detail ? 'tooltip tooltip-top' : '']"
                :data-tip="$tt('后台刮削')">
                <span class="loading loading-infinity loading-md text-primary" v-if="isLoading"></span>
                <span v-else :class="['flex mt-1', 'items-center', detail ? 'w-40' : '']">
                    <svg-icon name="sys-backend" class="w-16 h-5 fill-current" />
                    <div v-if="detail" class="mr-auto">{{ $tt('后台刮削') }}</div>
                </span>
            </div>
        </div>
    </div>

    <!-- 通用 Drawer (移动端和桌面端共用) -->
    <!-- 手动编辑 Drawer -->
    <div class="drawer">
        <input id="hand-edit" type="checkbox" class="drawer-toggle" v-model="handModifyCheckBox" />
        <div class="drawer-side z-50">
            <div @click="handModifyCheckBox = false" aria-label="close sidebar" class="drawer-overlay"></div>
            <div class="min-h-full bg-base-100 text-base-content w-full md:w-96 pb-20 md:pb-4 flex flex-col">
                <!-- 标准头部 -->
                <div class="flex items-center justify-between p-4 border-b border-base-200">
                    <div class="text-xl font-medium">{{ $tt('手动修改标签') }}</div>
                    <div>
                        <button class="btn btn-sm btn-neutral" @click="handleBatch(false)">{{ $tt('确认') }}</button>
                        <button class="btn btn-sm ml-1" @click="handModifyCheckBox = false">{{ $tt('取消') }}</button>
                    </div>
                </div>
                
                <!-- 内容区域 -->
                <div class="px-4">
                    <music-meta-data :music-info="musicInfoManual" :reload-img="reloadImg"
                            :drawer-mode="'drawer'" :mode="'form'">
                    </music-meta-data>
                </div>
            </div>
        </div>
    </div>

    <!-- 自动编辑 Drawer -->
    <div class="drawer">
        <input id="auto-edit" type="checkbox" class="drawer-toggle" name='auto-edit' v-model="autoModifyCheckBox" />
        <div class="drawer-side z-50">
            <div @click="autoModifyCheckBox = false" aria-label="close sidebar" class="drawer-overlay"></div>
            <div class="min-h-full bg-base-100 text-base-content w-full md:w-96 pb-20 md:pb-4 flex flex-col">
                <!-- 标准头部 -->
                <div class="flex items-center justify-between p-4 border-b border-base-200">
                    <div class="text-xl font-medium">{{ $tt('自动修改标签') }}</div>
                    <div>
                        <button class="btn btn-sm btn-neutral" @click="handleBatchAuto">{{ $tt('确认') }}</button>
                        <button class="btn btn-sm ml-1" @click="autoModifyCheckBox = false">{{ $tt('取消') }}</button>
                    </div>
                </div>
                
                <!-- 内容区域 -->
                <div class="flex-1 p-4 space-y-6 overflow-y-auto">
                    <!-- 说明信息 -->
                    <div class="bg-info/10 p-4 rounded-lg border border-info/20">
                        <div class="text-sm text-base-content/80 space-y-1">
                            <p>{{ $tt('根据元数据中的标题、艺术家、专辑和文件名、文件完整路径进行匹配。') }}</p>
                            <p>{{ $tt('标题、艺术家、专辑每一项匹配等级指标：完全一致，包含，不匹配') }}</p>
                        </div>
                    </div>

                    <!-- 匹配设置分组 -->
                    <div class="space-y-4">
                        <!-- 分组头部 -->
                        <div class="flex items-center space-x-3">
                            <div class="w-1 h-5 bg-primary/40 rounded-full"></div>
                            <h3 class="text-lg font-semibold text-base-content">{{ $tt('匹配设置') }}</h3>
                            <div class="badge badge-primary badge-outline badge-sm">{{ $tt('核心配置') }}</div>
                        </div>
                        
                        <!-- 分组内容 -->
                        <div class="ml-4 pl-3 border-l border-base-200 space-y-4">
                            <!-- 匹配模式 -->
                            <div class="form-control">
                                <label class="label">
                                    <span class="label-text font-medium">{{ $tt('匹配模式') }}</span>
                                </label>
                                <div class="space-y-2">
                                    <label class="label cursor-pointer justify-start gap-3 p-3 rounded-lg border border-base-200 hover:bg-base-50">
                                        <input type="radio" name="radio-auto-mode" class="radio radio-primary" value="simple" v-model="selectAutoMode" />
                                        <div class="flex-1">
                                            <div class="font-medium">{{ $tt('宽松模式') }}</div>
                                            <div class="text-xs text-base-content/70">{{ $tt('满足标题包含即可，但也优先选完全一致') }}</div>
                                        </div>
                                    </label>
                                    <label class="label cursor-pointer justify-start gap-3 p-3 rounded-lg border border-base-200 hover:bg-base-50">
                                        <input type="radio" name="radio-auto-mode" class="radio radio-primary" value="normal" v-model="selectAutoMode" />
                                        <div class="flex-1">
                                            <div class="font-medium">{{ $tt('标准模式') }}</div>
                                            <div class="text-xs text-base-content/70">{{ $tt('三个指标必须为包含或完全一致，但也优先选完全一致') }}</div>
                                        </div>
                                    </label>
                                    <label class="label cursor-pointer justify-start gap-3 p-3 rounded-lg border border-base-200 hover:bg-base-50">
                                        <input type="radio" name="radio-auto-mode" class="radio radio-primary" value="hard" v-model="selectAutoMode" />
                                        <div class="flex-1">
                                            <div class="font-medium">{{ $tt('严格模式') }}</div>
                                            <div class="text-xs text-base-content/70">{{ $tt('三个指标必须都为完全一致') }}</div>
                                        </div>
                                    </label>
                                </div>
                            </div>
                            
                            <!-- 刮削速率 -->
                            <!-- <div class="form-control">
                                <label class="label">
                                    <span class="label-text font-medium">{{ $tt('刮削速率') }}</span>
                                </label>
                                <div class="flex items-center space-x-3">
                                    <input type="number" placeholder="1" min="1" max="10" 
                                           class="input input-bordered input-sm w-32 font-mono"
                                           v-model="scrapeRate" />
                                    <span class="text-sm text-base-content/60">{{ $tt('文件/秒') }}</span>
                                </div>
                                <div class="mt-2 p-3 bg-base-200/50 rounded-lg">
                                    <div class="text-sm text-base-content/70">
                                        每秒刮削的音乐文件数量，基于你机器的性能和网络。
                                    </div>
                                </div>
                            </div> -->
                        </div>
                    </div>
                    
                    <!-- 数据源分组 -->
                    <div class="space-y-4">
                        <!-- 分组头部 -->
                        <div class="flex items-center space-x-3">
                            <div class="w-1 h-5 bg-base-content/20 rounded-full"></div>
                            <h3 class="text-lg font-semibold text-base-content">{{ $tt('数据源') }}</h3>
                            <div class="badge badge-ghost badge-sm">{{ $tt('标签源') }}</div>
                        </div>
                        
                        <!-- 分组内容 -->
                        <div class="ml-4 pl-3 border-l border-base-200 space-y-3">
                            <div class="form-control">
                                <label class="label">
                                    <span class="label-text font-medium">{{ $tt('标签源选择') }}</span>
                                </label>
                                <div class="multi-select-container">
                                    <multi-select :options="resourceListBatch" v-model="sourceList" />
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <!-- 修改范围分组 -->
                    <div class="space-y-4">
                        <!-- 分组头部 -->
                        <div class="flex items-center space-x-3">
                            <div class="w-1 h-5 bg-base-content/20 rounded-full"></div>
                            <h3 class="text-lg font-semibold text-base-content">{{ $tt('修改范围') }}</h3>
                            <div class="badge badge-ghost badge-sm">{{ $tt('字段选择') }}</div>
                        </div>
                        
                        <!-- 分组内容 -->
                        <div class="ml-4 pl-3 border-l border-base-200 space-y-3">
                            <div class="form-control">
                                <label class="label">
                                    <span class="label-text font-medium">{{ $tt('修改范围') }}</span>
                                </label>
                                <div class="multi-select-container">
                                    <multi-select :options="translateOptions(modifyListBatch)" v-model="modifyList" />
                                </div>
                            </div>
                        </div>
                    </div>

                    
                    <!-- 高级选项分组 -->
                    <div class="space-y-4">
                        <!-- 分组头部 -->
                        <div class="flex items-center space-x-3">
                            <div class="w-1 h-5 bg-base-content/20 rounded-full"></div>
                            <h3 class="text-lg font-semibold text-base-content">{{ $tt('高级选项') }}</h3>
                            <div class="badge badge-ghost badge-sm">{{ $tt('可选配置') }}</div>
                        </div>
                        
                        <!-- 分组内容 -->
                        <div class="ml-4 pl-3 border-l border-base-200 space-y-4">
                            <!-- 跳过匹配 -->
                            <label class="label cursor-pointer justify-start space-x-3 py-2">
                                <input type="checkbox" class="toggle toggle-primary" v-model="isSkipTag" />
                                <div class="flex-1">
                                    <span class="label-text font-medium">{{ $tt('跳过匹配') }}</span>
                                    <div class="text-xs text-base-content/60 mt-1">{{ $tt('如修改范围中元数据都存在，则跳过匹配，原有音乐标签将被保留，不会被修改或覆盖') }}</div>
                                </div>
                            </label>
                            
                            <!-- 同目录解释为同个专辑 -->
                            <label class="label cursor-pointer justify-start space-x-3 py-2">
                                <input type="checkbox" class="toggle toggle-primary" v-model="isFolderAlbum" />
                                <div class="flex-1">
                                    <span class="label-text font-medium">{{ $tt('同目录解释为同个专辑') }}</span>
                                    <div class="text-xs text-base-content/60 mt-1">{{ $tt('当元数据中不存在专辑信息，用于补充专辑信息，提高匹配度') }}</div>
                                </div>
                            </label>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <!-- 后台刮削 Drawer -->
    <div class="drawer">
        <input id="background-scrape" type="checkbox" class="drawer-toggle" v-model="backgroundScrapeCheckBox" />
        <div class="drawer-side z-50">
            <div @click="backgroundScrapeCheckBox = false" aria-label="close sidebar" class="drawer-overlay"></div>
            <div class="min-h-full bg-base-100 text-base-content w-full md:w-96 pb-20 md:pb-4 flex flex-col">
                <!-- 标准头部 -->
                <div class="flex items-center justify-between p-4 border-b border-base-200">
                    <div class="text-xl font-medium">{{ $tt('后台刮削配置') }}</div>
                    <div>
                        <button class="btn btn-sm btn-neutral" @click="handleBackgroundScrape" v-if="role === 'V2'">{{ $tt('确认') }}</button>
                        <button class="btn btn-sm" @click="backgroundScrapeCheckBox = false">{{ $tt('取消') }}</button>
                    </div>
                </div>

                <!-- 内容区域 -->
                <div class="flex-1 p-4 space-y-6 overflow-y-auto">
                    <!-- 提示信息 -->
                    <div class="bg-info/10 p-4 rounded-lg border border-info/20">
                        <div class="flex items-start space-x-3">
                            <svg class="w-5 h-5 text-info flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"></path>
                            </svg>
                            <div class="flex-1 text-sm text-base-content/80 space-y-2">
                                <p class="font-medium text-base-content">{{ $tt('后台刮削配置说明') }}</p>
                                <p>{{ $tt('后台刮削功能的表单配置与系统设置中的后台刮削配置完全一致。') }}</p>
                                <p>{{ $tt('如需修改配置,请前往:') }}</p>
                                <router-link v-if="role === 'V2'" to="/system" class="btn btn-sm btn-primary mt-2 inline-flex items-center space-x-2">
                                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"></path>
                                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                                    </svg>
                                    <span>{{ $tt('前往系统设置') }}</span>
                                </router-link>
                            </div>
                        </div>
                    </div>

                    <!-- 功能说明 -->
                    <div class="space-y-4">
                        <div class="flex items-center space-x-3">
                            <div class="w-1 h-5 bg-primary/40 rounded-full"></div>
                            <h3 class="text-lg font-semibold text-base-content">{{ $tt('后台刮削功能') }}</h3>
                        </div>

                        <div class="ml-4 pl-3 border-l border-base-200 space-y-3">

                            <div class="bg-base-200/30 p-3 rounded-lg">
                                <div class="font-medium text-base-content mb-2">{{ $tt('音乐预处理') }}</div>
                                <div class="text-sm text-base-content/70">
                                    {{ $tt('包括复制文件、声纹识别、乱码修复、繁体转简体等预处理操作') }}
                                </div>
                            </div>

                            <div class="bg-base-200/30 p-3 rounded-lg">
                                <div class="font-medium text-base-content mb-2">{{ $tt('音乐自动刮削') }}</div>
                                <div class="text-sm text-base-content/70">
                                    {{ $tt('自动从音乐流媒体平台搜索元数据并进行刮削,支持自动模式和手动模式') }}
                                </div>
                            </div>

                            <div class="bg-base-200/30 p-3 rounded-lg">
                                <div class="font-medium text-base-content mb-2">{{ $tt('音乐文件整理') }}</div>
                                <div class="text-sm text-base-content/70">
                                    {{ $tt('按照设定的规则整理音乐文件目录结构,支持洗版功能') }}
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 注意事项 -->
                    <div class="bg-warning/10 p-4 rounded-lg border border-warning/20">
                        <div class="flex items-start space-x-3">
                            <svg class="w-5 h-5 text-warning flex-shrink-0 mt-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"></path>
                            </svg>
                            <div class="flex-1 text-sm text-base-content/80 space-y-1">
                                <p class="font-medium text-base-content">{{ $tt('注意事项') }}</p>
                                <ul class="list-disc list-inside space-y-1">
                                    <li>{{ $tt('操作台的后台刮削只对勾选的文件进行刮削') }}</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>

<script>
import SingleSelect from "@/components/iview/SingleSelect";
import SingleInput from "@/components/iview/SingleInput";
import MultiSelect from "@/components/iview/MultiSelect";
import musicMetaData from "@/views/home/musicMetaData.vue";
import { mapGetters } from 'vuex';
import SvgIcon from '@/components/SvgIcon.vue';
export default {
    name: 'TagEditor',
    components: { SingleInput, SingleSelect, MultiSelect, musicMetaData, SvgIcon },
    props: {
        detail: {
            type: Boolean,
            default: false
        },
        isLoading: {
            type: Boolean,
            default: false
        },
        checkedData: {
            type: Array,
            default: () => []
        },
        filePath: {
            type: String,
            default: ''
        },
        cardMode: {
            type: Boolean,
            default: false
        }
    },
    
    data() {
        // 辅助函数：从 localStorage 获取值
        const getLocalStorageValue = (key, defaultValue) => {
            try {
                const value = localStorage.getItem(key)
                if (value !== null) {
                    return JSON.parse(value)
                }
            } catch (e) {
                console.warn(`Failed to parse localStorage value for key: ${key}`, e)
            }
            return defaultValue
        }

        return {
            handModifyCheckBox: false,
            autoModifyCheckBox: false,
            backgroundScrapeCheckBox: false,
            musicInfoManual: {},
            showFields: localStorage.getItem('showFields') ? JSON.parse(localStorage.getItem('showFields')) : ['filename', 'artist', 'album', 'albumartist', 'genre', 'year', 'lyrics', 'lyrics_file', 'comment', 'album_img', 'size', 'album_type', 'description', 'discnumber', 'tracknumber', 'totaltracks', 'totaldiscs', 'bit_rate', 'sample_rate', 'channels', 'bit_depth', 'language', 'duration'],
            albumTypeList: [
                { id: 'album;album', name: '普通(album;album)' },
                { id: 'ep', name: 'EP(ep)' },
                { id: 'album;compilation', name: '合集(album;compilation)' },
                { id: 'album;live', name: '现场(album;live)' },
                { id: 'album;remix', name: '混音(album;remix)' },
                { id: 'album;soundtrack', name: '原声(album;soundtrack)' },
                { id: 'album;demo', name: '演示(album;demo)' },
                { id: 'single', name: '单曲(single)' }
            ],
            isSaveLyricsFile: false,
            isSaveAlbumCover: false,
            isImportAlbumCover: false,
            isImportLyricsFile: false,
            isTranslateLyrics: false,
            reloadImg: true,
            uploadUrl: '/apimt/upload_image/',
            files1: [],
            genreList: [
                { 'id': '流行', name: '流行' },
                { 'id': '摇滚', name: '摇滚' },
                { 'id': '说唱', name: '说唱' },
                { 'id': '民谣', name: '民谣' },
                { 'id': '电子', name: '电子' },
                { 'id': '爵士', name: '爵士' },
                { 'id': '纯音乐', name: '纯音乐' },
                { 'id': '金属', name: '金属' },
                { 'id': '古典', name: '古典' },
                { 'id': '独立', name: '独立' },
            ],
            languageList: [
                { 'id': '中文', name: '中文' },
                { 'id': '英文', name: '英文' },
                { 'id': '日文', name: '日文' },
                { 'id': '韩文', name: '韩文' },
                { 'id': '泰文', name: '泰文' },
                { 'id': '未知', name: '未知' },
                { 'id': '${guess_language}', name: '自动识别' }
            ],
            albumArtistList: [],
            // 从 localStorage 读取自动编辑表单数据，如果不存在则使用默认值
            isSkipTag: getLocalStorageValue('autoEdit_isSkipTag', true),
            isFolderAlbum: getLocalStorageValue('autoEdit_isFolderAlbum', false),
            scrapeRate: getLocalStorageValue('autoEdit_scrapeRate', 1),
            modifyList: getLocalStorageValue('autoEdit_modifyList', ['artist', 'album', 'album_img', 'year', 'lyrics']),
            resourceListBatch: [],
            modifyListBatch: [
                { id: 'title', name: '标题' },
                { id: 'artist', name: '艺术家' },
                { id: 'album', name: '专辑' },
                { id: 'albumartist', name: '专辑艺术家' },
                { id: 'album_img', name: '专辑封面' },
                { id: 'year', name: '年份' },
                { id: 'lyrics', name: '歌词' },
                { id: 'is_save_lyrics_file', name: '歌词(LRC文件)' },
                { id: 'discnumber', name: '光盘编号' },
                { id: 'tracknumber', name: '音轨号' },
                { id: 'composer', name: '作曲家' },
                { id: 'lyricist', name: '作词家' },
                { id: 'language', name: '语言' }
            ],
            selectAutoMode: getLocalStorageValue('autoEdit_selectAutoMode', 'simple'),
            sourceList: getLocalStorageValue('autoEdit_sourceList', ['netease', 'qmusic']),
             // 新增的图片上传相关数据
             albumImagePreview: null,
            isUploadingAlbumImage: false,
        }
    },
    mounted() {
        // 加载标签源列表
        this.loadTagSourcesFromStore();
    },
    computed: {
        ...mapGetters({
                role: 'getUserRole',
            }),
        uploadHeader() {
            return [
                { name: 'X-CSRFToken', value: this.getCookie('django_vue_cli_csrftoken') },
                { name: 'AUTHORIZATION', value: this.getCookie('AUTHORIZATION') }
            ];
        }
    },
    methods: {
        translateOptions(options) {
            return (options || []).map(item => ({
                ...item,
                name: this.$tt(item.name)
            }))
        },
        // 从 Vuex store 加载标签源列表
        async loadTagSourcesFromStore() {
            try {
                // 从 Vuex store 加载标签源（带缓存）
                const sources = await this.$store.dispatch('loadTagSources')

                // 过滤掉 smart_tag
                const excludeIds = ['smart_tag', 'acoustid', 'musicbrainz']
                this.resourceListBatch = sources.filter(plugin => !excludeIds.includes(plugin.id));


                // 过滤sourceList，只保留在resourceListBatch中存在的项目
                const availableSourceIds = this.resourceListBatch.map(item => item.id)
                this.sourceList = this.sourceList.filter(sourceId => availableSourceIds.includes(sourceId))

                // 如果过滤后sourceList为空，设置默认值
                if (this.sourceList.length === 0 && this.resourceListBatch.length > 0) {
                    this.sourceList = [this.resourceListBatch[0].id]
                }
            } catch (error) {
                console.error('加载标签源失败:', error)
            }
        },
        // 移除专辑封面
        removeAlbumImage() {
            this.albumImagePreview = null
            this.musicInfoManual.album_img = ''
            this.musicInfoManual.artwork = ''
            if (this.$refs.albumImageInput) {
                this.$refs.albumImageInput.value = ''
            }
        },
        // 触发专辑封面替换
        triggerAlbumImageReplacement() {
            // 直接创建临时input，更可靠
            this.createTempFileInput('album')
        },
        
        // 创建临时文件输入
        createTempFileInput(type) {
            const input = document.createElement('input')
            input.type = 'file'
            input.accept = 'image/*'
            input.style.display = 'none'
            input.onchange = (event) => {
                if (type === 'album') {
                    this.handleAlbumImageChange(event)
                } else {
                    this.handleArtistImageChange(event)
                }
                // 清理临时元素
                if (input.parentNode) {
                    input.parentNode.removeChild(input)
                }
            }
            document.body.appendChild(input)
            input.click()
        },
        // 渲染图片
        handleRes(response) {
            if (response.result) {
                this.musicInfoManual.album_img = response.data
                return true
            } else {
                return false
            }
        },
        // 新增的图片上传相关方法
        // 处理专辑封面图片选择
        handleAlbumImageChange(event) {
            const file = event.target.files[0]
            if (!file) return
            
            // 验证文件类型
            if (!file.type.startsWith('image/')) {
                this.$myMsg.notify({
                    title: this.$tt('文件类型错误'),
                    content: this.$tt('请选择图片文件'),
                    type: 'error',
                    time: 2000,
                })
                return
            }
            
            // 验证文件大小 (5MB)
            if (file.size > 5 * 1024 * 1024) {
                this.$myMsg.notify({
                    title: this.$tt('文件过大'),
                    content: this.$tt('图片大小不能超过5MB'),
                    type: 'error',
                    time: 2000,
                })
                return
            }
            
            // 显示预览
            const reader = new FileReader()
            reader.onload = (e) => {
                this.albumImagePreview = e.target.result
            }
            reader.readAsDataURL(file)
            
            // 上传图片
            this.uploadImage(file, 'album')
        },
        // 处理艺术家图片选择
        handleArtistImageChange(event) {
            const file = event.target.files[0]
            if (!file) return
            
            // 验证文件类型
            if (!file.type.startsWith('image/')) {
                this.$myMsg.notify({
                    title: this.$tt('文件类型错误'),
                    content: this.$tt('请选择图片文件'),
                    type: 'error',
                    time: 2000,
                })
                return
            }
            
            // 验证文件大小 (5MB)
            if (file.size > 5 * 1024 * 1024) {
                this.$myMsg.notify({
                    title: this.$tt('文件过大'),
                    content: this.$tt('图片大小不能超过5MB'),
                    type: 'error',
                    time: 2000,
                })
                return
            }
            
            // 上传图片
            this.uploadImage(file, 'artist')
        },
        // 通用图片上传方法
        uploadImage(file, type) {
            const formData = new FormData()
            formData.append('upload_file', file)
            
            // 设置上传状态
            if (type === 'album') {
                this.isUploadingAlbumImage = true
            } else {
                this.isUploadingArtistImage = true
            }
            
            // 创建 XMLHttpRequest
            const xhr = new XMLHttpRequest()
            
            // 设置请求头
            xhr.open('POST', this.uploadUrl, true)
            xhr.setRequestHeader('X-CSRFToken', this.getCookie('django_vue_cli_csrftoken'))
            xhr.setRequestHeader('AUTHORIZATION', this.getCookie('AUTHORIZATION'))
            xhr.withCredentials = true
            
            // 处理响应
            xhr.onload = () => {
                // 重置上传状态
                if (type === 'album') {
                    this.isUploadingAlbumImage = false
                } else {
                    this.isUploadingArtistImage = false
                }
                
                if (xhr.status === 200) {
                    try {
                        const response = JSON.parse(xhr.responseText)
                        if (this.handleRes(response)) {
                            this.$myMsg.notify({
                                title: this.$tt('上传成功'),
                                type: 'success',
                                time: 2000,
                            })
                        } else {
                            this.$myMsg.notify({
                                title: this.$tt('上传失败'),
                                content: response.message || this.$tt('未知错误'),
                                type: 'error',
                                time: 2000,
                            })
                        }
                    } catch (e) {
                        console.log(e)
                        this.$myMsg.notify({
                            title: this.$tt('上传失败'),
                            content: this.$tt('服务器响应格式错误'),
                            type: 'error',
                            time: 2000,
                        })
                    }
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('上传失败'),
                        content: `HTTP错误: ${xhr.status}`,
                        type: 'error',
                        time: 2000,
                    })
                }
            }
            
            // 处理错误
            xhr.onerror = () => {
                if (type === 'album') {
                    this.isUploadingAlbumImage = false
                } else {
                    this.isUploadingArtistImage = false
                }
                this.$myMsg.notify({
                    title: this.$tt('上传失败'),
                    content: this.$tt('网络错误'),
                    type: 'error',
                    time: 2000,
                })
            }
            
            // 发送请求
            xhr.send(formData)
        },
        handleBatch(isRegainer) {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: this.$tt('发生提示'),
                    content: this.$tt('请先勾选文件或文件夹！'),
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')


            this.$api.Task.batchUpdateId3({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'music_info': this.musicInfoManual,
                'is_regainer': isRegainer
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.handModifyCheckBox = false
                    this.$myMsg.notify({
                        title: this.$tt('创建成功！'),
                        content: this.$tt('任务在后台努力运行中'),
                        type: 'success',
                        time: 2000,
                        url: '/#/log'
                    });
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: res.message.data.message ? res.message.data.message: this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },

        handleBatchAuto() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: this.$tt('发生提示'),
                    content: this.$tt('请先勾选文件或文件夹！'),
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            // 保存自动编辑表单设置到 localStorage
            this.saveAutoEditSettings()

            this.$emit('loading-start')

            this.musicInfoManual['select_mode'] = this.selectAutoMode
            this.musicInfoManual['source_list'] = this.sourceList
            this.musicInfoManual['is_skip_tag'] = this.isSkipTag
            this.musicInfoManual['is_folder_album'] = this.isFolderAlbum
            this.musicInfoManual['scrape_rate'] = this.scrapeRate

            this.$api.Task.batchAutoUpdateId3({
                'file_full_path': this.filePath,
                'select_data': this.checkedData,
                'music_info': this.musicInfoManual,
                'modify_list': this.modifyList
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.autoModifyCheckBox = false
                    this.$myMsg.notify({
                        title: this.$tt('创建成功！'),
                        content: this.$tt('任务在后台努力运行中'),
                        type: 'success',
                        time: 2000,
                        url: '/#/log'
                    });
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: res.message.data.message ? res.message.data.message: this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },
        handleBackgroundScrape() {
            if (this.checkedData.length === 0) {
                this.$myMsg.notify({
                    title: this.$tt('发生提示'),
                    content: this.$tt('请先勾选文件或文件夹！'),
                    type: 'warning',
                    time: 5000,
                });
                return
            }

            this.$emit('loading-start')

            this.$api.Task.batchBackgroundScrape({
                'file_full_path': this.filePath,
                'select_data': this.checkedData
            }).then((res) => {
                this.$emit('loading-end')
                if (res.result) {
                    this.backgroundScrapeCheckBox = false
                    this.$myMsg.notify({
                        title: this.$tt('创建成功！'),
                        content: this.$tt('任务在后台努力运行中'),
                        type: 'success',
                        time: 2000,
                        url: '/#/log'
                    });
                } else {
                    this.$myMsg.notify({
                        title: this.$tt('创建失败！'),
                        content: res.message.data.message ? res.message.data.message: this.$tt('创建失败'),
                        type: 'error',
                        time: 5000,
                    })
                }
            }).catch(() => {
                this.$emit('loading-end')
            })
        },
        // 保存自动编辑设置到 localStorage
        saveAutoEditSettings() {
            try {
                localStorage.setItem('autoEdit_selectAutoMode', JSON.stringify(this.selectAutoMode))
                localStorage.setItem('autoEdit_sourceList', JSON.stringify(this.sourceList))
                localStorage.setItem('autoEdit_modifyList', JSON.stringify(this.modifyList))
                localStorage.setItem('autoEdit_isSkipTag', JSON.stringify(this.isSkipTag))
                localStorage.setItem('autoEdit_isFolderAlbum', JSON.stringify(this.isFolderAlbum))
                localStorage.setItem('autoEdit_scrapeRate', JSON.stringify(this.scrapeRate))
            } catch (e) {
                console.warn('Failed to save auto edit settings to localStorage:', e)
            }
        },

        handleResBatch(response) {
            if (response.result) {
                this.musicInfoManual.album_img = response.data
                return true
            } else {
                return false
            }
        },

        handleHide() {
            this.musicInfoManual.album_img = ''
        },

        getCookie(name) {
            let cookieValue = null;
            if (document.cookie && document.cookie !== '') {
                const cookies = document.cookie.split(';');
                for (let i = 0; i < cookies.length; i++) {
                    const cookie = cookies[i].trim();
                    if (cookie.substring(0, name.length + 1) === (name + '=')) {
                        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
                        break;
                    }
                }
            }
            return cookieValue;
        }
    }
}
</script>

<style scoped>
.icon {
    @apply fill-current w-16;
}

.edit-item {
    display: flex;
    margin-bottom: 10px;
    align-items: center;
    margin-top: 10px;
}

.label1 {
    width: 30%;
    font-weight: 500;
}

.can-copy {
    cursor: pointer;
}

.multi-select-container {
    @apply bg-base-200/30 rounded-lg p-3 border border-base-300/50;
}
</style>
